module.exports = __webpack_public_path__ + "static/media/detail-banner.b94a738c.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/detail-banner.png
// module id = 749
// module chunks = 0